// extracted by mini-css-extract-plugin
export default {"form":"FormItem_form__0aAGA alude-form","justifyInput":"FormItem_justifyInput__2dmJ2"};